import list from "./list";
import edit from "./edit";

export default {
  namespaced: true,
  modules: {
    list: { namespaced: true, ...list },
    edit: { namespaced: true, ...edit }
  }
};
